<template>
    <svg class="w-[18px] h-[18px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" stroke="currentColor">
        <path d="M3.80262 11.8026L1 9M1 9L3.80262 6.19738M1 9H17M14.1974 11.8026L17 9M17 9L14.1974 6.19738M6.19738 3.80262L9 1M9 1L11.8026 3.80262M9 1L9 17M6.19738 14.1974L9 17M9 17L11.8026 14.1974" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>